import rg4js from 'raygun4js';

const MAX_LENGTH = 255;
const truncate = (value = '') => (value.length > MAX_LENGTH ? value.slice(0, MAX_LENGTH) : value);

let initialized = false;

export const initRaygun = () => {
  if (initialized || typeof window === 'undefined') {
    return;
  }

  const apiKey = process.env.REACT_APP_RAYGUN_KEY || process.env.RAYGUN_KEY;

  if (!apiKey) {
    // eslint-disable-next-line no-console
    console.warn('Raygun API key not configured; skipping initialization.');
    return;
  }

  rg4js('apiKey', apiKey);
  rg4js('enableCrashReporting', true);
  rg4js('enableRealUserMonitoring', true);
  rg4js('setUser', { isAnonymous: true });

  initialized = true;

  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_RAYGUN_TEST === 'true') {
    // Delay to ensure Raygun registers before the test exception is thrown.
    setTimeout(() => {
      throw new Error('This is a test exception');
    }, 0);
  }
};

export const setRaygunUser = (user) => {
  if (!initialized) {
    return;
  }

  if (!user) {
    rg4js('endSession');
    rg4js('setUser', { isAnonymous: true });
    return;
  }

  const {
    _id,
    email = '',
    firstName = '',
    lastName = '',
    fullName,
  } = user;

  const composedFullName = fullName || [firstName, lastName].filter(Boolean).join(' ');

  rg4js('setUser', {
    identifier: truncate(_id || email || 'anonymous'),
    isAnonymous: false,
    email: truncate(email),
    firstName: truncate(firstName),
    fullName: truncate(composedFullName || firstName || email),
  });
};

export const clearRaygunUser = () => {
  if (!initialized) {
    return;
  }

  rg4js('endSession');
  rg4js('setUser', { isAnonymous: true });
};

export default initRaygun;
